import { useEffect, useMemo, useState } from 'react';
import Modal from './Modal';
import TagTokenInput from './TagTokenInput';

const DEFAULT_FILTERS = {
  search: '',
  sourceNumber: '',
  tagsAll: [],
  tagsAny: [],
  tagsNot: [],
  sortField: 'site',
  sortOrder: 'asc',
  includeNotEge: false,
};

export default function CollaborativeTaskSearchModal({
  open,
  onClose,
  initialFilters,
  onApply,
  onReset,
}) {
  const seed = useMemo(() => ({ ...DEFAULT_FILTERS, ...(initialFilters || {}) }), [initialFilters]);
  const [filters, setFilters] = useState(seed);

  useEffect(() => {
    if (!open) return;
    setFilters(seed);
  }, [open, seed]);

  function resetLocal() {
    setFilters(DEFAULT_FILTERS);
    onReset?.();
  }

  return (
    <Modal open={open} title="Поиск задач" onClose={onClose}>
      <form
        className="collab-task-search-modal"
        onSubmit={(e) => {
          e.preventDefault();
          onApply?.(filters);
        }}
      >
        <div className="form-group">
          <label htmlFor="collab-task-source-number">Номер задачи</label>
          <input
            id="collab-task-source-number"
            type="text"
            inputMode="numeric"
            className="form-input"
            placeholder="Точный номер в источнике или номер на сайте"
            value={filters.sourceNumber}
            onChange={(e) => setFilters((prev) => ({ ...prev, sourceNumber: e.target.value }))}
          />
        </div>

        <div className="form-group">
          <label>Полнотекстовый поиск</label>
          <input
            type="text"
            className="form-input"
            placeholder="Например, «циклы» или фраза из текста задачи"
            value={filters.search}
            onChange={(e) => setFilters((prev) => ({ ...prev, search: e.target.value }))}
          />
        </div>

        <TagTokenInput
          label="Теги (все обязательны)"
          value={filters.tagsAll}
          onChange={(tagsAll) => setFilters((prev) => ({ ...prev, tagsAll }))}
        />
        <TagTokenInput
          label="Хотя бы один из тегов"
          value={filters.tagsAny}
          onChange={(tagsAny) => setFilters((prev) => ({ ...prev, tagsAny }))}
        />
        <TagTokenInput
          label="Исключить теги"
          value={filters.tagsNot}
          onChange={(tagsNot) => setFilters((prev) => ({ ...prev, tagsNot }))}
        />

        <div className="catalog-sort-row" style={{ marginTop: '0.75rem' }}>
          <div className="form-group catalog-sort-field">
            <label htmlFor="collab-catalog-sort-field">Сортировка</label>
            <select
              id="collab-catalog-sort-field"
              className="form-select"
              value={filters.sortField === 'source' ? 'source' : 'site'}
              onChange={(e) =>
                setFilters((prev) => ({ ...prev, sortField: e.target.value === 'source' ? 'source' : 'site' }))
              }
            >
              <option value="site">Номер на сайте</option>
              <option value="source">Номер в источнике</option>
            </select>
          </div>
          <div className="form-group catalog-sort-field">
            <label htmlFor="collab-catalog-sort-order">Направление</label>
            <select
              id="collab-catalog-sort-order"
              className="form-select"
              value={filters.sortOrder === 'desc' ? 'desc' : 'asc'}
              onChange={(e) =>
                setFilters((prev) => ({ ...prev, sortOrder: e.target.value === 'desc' ? 'desc' : 'asc' }))
              }
            >
              <option value="asc">По возрастанию</option>
              <option value="desc">По убыванию</option>
            </select>
          </div>
        </div>

        <div className="form-group" style={{ marginTop: '0.75rem' }}>
          <label
            htmlFor="collab-include-not-ege"
            title="ОГЭ и другие задачи вне ЕГЭ. Снятые с карты остаются скрыты."
          >
            <input
              id="collab-include-not-ege"
              type="checkbox"
              checked={Boolean(filters.includeNotEge)}
              onChange={(e) => setFilters((prev) => ({ ...prev, includeNotEge: e.target.checked }))}
            />{' '}
            Показать не ЕГЭ
          </label>
        </div>

        <div className="catalog-modal-actions" style={{ marginTop: '0.75rem' }}>
          <button type="button" className="btn btn-outline" onClick={onClose}>
            Отмена
          </button>
          <button type="button" className="btn btn-outline" onClick={resetLocal}>
            Сбросить
          </button>
          <button type="submit" className="btn btn-primary">
            Применить
          </button>
        </div>
      </form>
    </Modal>
  );
}

